var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:_vm.$vuetify.theme.dark ? 'content-dark' : 'content-light'},[_c('NavBar',{attrs:{"activeUser":_vm.activeUser},on:{"logout":_vm.logout,"login":_vm.login}}),_c('v-main',{class:(_vm.$vuetify.theme.dark ? 'main-content--dark ' : 'main-content ') +
      ' pb-5'},[_c('v-container',{staticClass:"my-4 px-5"},[_c('router-view',{attrs:{"activeUser":_vm.activeUser}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }